import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import Badge from "@material-ui/core/Badge";
import { withStyles } from "@material-ui/core/styles";
import Radio from "@material-ui/core/Radio";
import SettingsIcon from "@material-ui/icons/Settings";
import IconButton from "@material-ui/core/IconButton";

import db from "../../../../../firebase/firebase";

import { selectUser } from "../../../../../store/reducers/userSlice";
import {
  selectCharacter,
  setActiveCharacter,
  setCharacter,
} from "../../../../../store/reducers/characterSlice";
import Portrait from "../../../../../hooks/Portrait/Portrait";
import classes from "./Character.module.css";


function Character({ id, character }) {
  const history = useHistory();
  const dispatch = useDispatch();
  const characterData = useSelector(selectCharacter);
  const user = useSelector(selectUser);

  const handleSelectCharacter = () => {
    dispatch(setActiveCharacter(id));
    dispatch(setCharacter(character));
    db.collection("users").doc(user.uid).update({
      avatar: character.character.characterName,
      portrait: character.character.characterPortrait,
      id: id,
      character: character,
    });
  };

  // const handleSelectCharacter = () => {
  //   dispatch(setActiveCharacter(id));
  //   dispatch(setCharacter(character));
  // };

  function handleSelectProfile() {
    history.push("/profile");
    handleSelectCharacter();
    //dispatch(setCharacter(character));
  }

  const GoldRadio = withStyles({
    root: {
      color: "gold",
      "&$checked": {
        color: "gold",
      },
    },
    checked: {},
  })((props) => <Radio color="default" {...props} />);

  let radio = (
    <Radio
      checked={false}
      onClick={handleSelectCharacter}
      value="c"
      name="radio-button-demo"
      inputProps={{ "aria-label": "C" }}
    />
  );
  if (id === characterData.activeCharacter) {
    radio = (
      <GoldRadio
        checked={true}
        onClick={handleSelectCharacter}
        value="c"
        name="radio-button-demo"
        inputProps={{ "aria-label": "C" }}
      />
    );
  }
  return (
    <div className={classes.sidebar__channelsHeader}>
      <div className={classes.avatar}>
        <Badge
          overlap="circle"
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          badgeContent={
            <IconButton
              color="primary"
              fontSize="small"
              aria-label="add an alarm"
              alt="Settings"
              className={classes.badge}
              onClick={handleSelectProfile}
            >
              <SettingsIcon />
            </IconButton>
          }
        >
          {/* <div className={classes.profile__spheres}>
            <img src={banner} className={classes.banner}></img>
            <img
              src={character.character.characterPortrait}
              className={classes.profile__portrait__img}
              alt="Logo"
              loading="lazy"
            />

          </div> */}
          <div className={classes.portrait}>
          <Portrait character={character.character}/>
          </div>
        </Badge>
      </div>
      <div onClick={handleSelectCharacter}>
        <h4 className={classes.clickable}>
          {character.character.characterName}
        </h4>
      </div>

      <div className={classes.sidebar__selectCharacter}>{radio}</div>
    </div>
  );
}

export default Character;
